export const STORAGE_URL = 'https://s.immersivo.co/'

export const TWO_DRAWERS_MIN_WIDTH = 1000;

export const MAGIC_ZOOM_DISTANCE = 0.2;